import { render, staticRenderFns } from "./CatalogList.vue?vue&type=template&id=3c8312c9&scoped=true"
import script from "./CatalogList.vue?vue&type=script&lang=js"
export * from "./CatalogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8312c9",
  null
  
)

export default component.exports